import {
  DIRECTION_LEFT,
  DIRECTION_DOWN,
  DIRECTION_RIGHT,
  DIRECTION_UP,
  PLACEMENT_TYPE_HERO,
} from "../helpers/consts";
import { BodyPlacement } from "./BodyPlacement";
import CharacterBody from "../components/object-graphics/CharacterBody";
import { TILES } from "../helpers/tiles";

const HORIZONTAL = "HORIZONTAL";
const VERTICAL = "VERTICAL";
const ENEMY_MOVE_SPEED = 20;

export class EnemyPlacement extends BodyPlacement {
  constructor(properties, level) {
    super(properties, level);
    this.axis =
      this.facingDirection === DIRECTION_LEFT ||
      this.facingDirection === DIRECTION_RIGHT
        ? HORIZONTAL
        : VERTICAL;

    this.waitFramesBeforeAIMove = ENEMY_MOVE_SPEED;
    this.framesUntilAiMove = this.waitFramesBeforeAIMove;

    this.lastMovedAxisDirection = this.facingDirection;
    this.enemyTickCheckForHero = true;
  }

  _updateLastMovedAxisDirection() {
    if (this.axis === HORIZONTAL) {
      if (
        this.movingPixelDirection === DIRECTION_RIGHT ||
        this.movingPixelDirection === DIRECTION_LEFT
      ) {
        this.lastMovedAxisDirection = this.movingPixelDirection;
      }
    }
    if (this.axis === VERTICAL) {
      if (
        this.movingPixelDirection === DIRECTION_UP ||
        this.movingPixelDirection === DIRECTION_DOWN
      ) {
        this.lastMovedAxisDirection = this.movingPixelDirection;
      }
    }
  }

  _handleAIMove() {
    this._updateLastMovedAxisDirection();

    if (this._nextSpaceIsFree(this.lastMovedAxisDirection)) {
      //First try my intended direction
      this._move(this.lastMovedAxisDirection);
    } else if (this._nextSpaceIsFree(this.movingPixelDirection)) {
      //If that didn't work, try the direction I am moving (like if on a Conveyor)
      //This logic came from a bug where enemies would behave funny when on a Conveyor on the other axis
      this._move(this.movingPixelDirection);
    } else {
      //Flip direction
      this._switchDirection();
    }
  }

  _switchDirection() {
    if (this.axis === HORIZONTAL) {
      if (this.movingPixelDirection === DIRECTION_LEFT) {
        this.movingPixelDirection = DIRECTION_RIGHT;
        this.level.updateLivePlacement(this, {
          facingDirection: DIRECTION_RIGHT,
        });
      } else {
        this.movingPixelDirection = DIRECTION_LEFT;
        this.level.updateLivePlacement(this, {
          facingDirection: DIRECTION_LEFT,
        });
      }
    }
    if (this.axis === VERTICAL) {
      if (this.movingPixelDirection === DIRECTION_UP) {
        this.movingPixelDirection = DIRECTION_DOWN;
      } else {
        this.movingPixelDirection = DIRECTION_UP;
      }
    }
  }

  damagesBodyOnCollide(forBody) {
    return forBody.type === PLACEMENT_TYPE_HERO;
  }

  handleEnemyCollideWithHero() {
    this.level.setDeathType(this.type);
  }

  renderComponent() {
    const frameCoord =
      this.facingDirection === DIRECTION_LEFT
        ? TILES.ENEMY_LEFT
        : TILES.ENEMY_RIGHT;
    return (
      <CharacterBody
        bodyFrameCoord={frameCoord}
        hop={true}
        movingPixelsRemaining={this.movingPixelsRemaining}
      />
    );
  }
}
